'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _analyticsTraffic = require('./analytics-traffic.component');

var _analyticsTraffic2 = _interopRequireDefault(_analyticsTraffic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsModule = _angular2.default.module('app.containers.analytics-traffic', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('analyticsTraffic', {
    url: '/analytics-traffic',
    template: '<analytics-traffic></analytics-traffic>'
  });
}).component('analyticsTraffic', _analyticsTraffic2.default);

exports.default = analyticsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-traffic/analytics-traffic.js
 **/